// extracted by mini-css-extract-plugin
module.exports = {"container":"Explain_container__raS7Q","mobile":"Explain_mobile__2RHWR"};